import { Preferences } from '@capacitor/preferences';

export async function cerrarSesion(){
    await Preferences.remove({ key: 'rut'           });
    await Preferences.remove({ key: 'nombres'       });
    await Preferences.remove({ key: 'apellido_p'    });
    await Preferences.remove({ key: 'apellido_m'    });
    await Preferences.remove({ key: 'tipo_usuario'  });
    await Preferences.remove({ key: 'modo_oscuro'   });
    await Preferences.remove({ key: 'cambio_clave'  });
    await Preferences.remove({ key: 'clave'         });
    await Preferences.remove({ key: 'token_noti'    });
    await Preferences.remove({ key: 'token_auth'    });
    window.location.replace("/");
}